import React, {useState} from 'react'
import {type ButtonProps, ButtonWithModal, Icon} from '@therms/atalaya'
import {
  Alerts,
  RPCDocs,
  useLocationContext,
  UserAnPCheck,
  useRPCContext,
} from '@therms/react-modules'
import {NewRecordModal} from '@src/modules/Records/router/screens/Index/components/NewRecordModal'
import {RECORDS_ROUTES} from '@src/modules/Records/constants'
import {generatePath, useHistory} from 'react-router-dom'
import {IoMdAdd} from 'react-icons/io'
import {BulkImportRecordsModal} from '@src/modules/Records/shared/BulkImportRecords/BulkImportRecords.tsx'

function NewRecordButton({
  children,
  onComplete,
  ...buttonProps
}: Omit<ButtonProps, 'children' | 'onClick'> & {
  children?: React.ReactNode
  onComplete?: () => void
}) {
  const history = useHistory()
  const {rpcService} = useRPCContext()
  const location = useLocationContext()
  const [recordType, setRecordType] = useState<
    RPCDocs.Records.CreateRecord.v1.Type | undefined
  >()
  const [bulkImport, setBulkImport] = useState(false)

  const save = async (type: RPCDocs.Records.CreateRecord.v1.Type) => {
    let response
    try {
      response = await rpcService.Records.CreateRecord.v1.call({
        record: {
          fields: {},
          type,
        },
        refLinks: location
          ? [
              {
                type: RPCDocs.Records.CreateRecord.v1.RefLinksType.Location,
                value: location.locationId,
              },
            ]
          : undefined,
      })

      Alerts.success('Record created')

      history.push(
        generatePath(RECORDS_ROUTES.VIEW_RECORD, {
          recordId: response?.data?.recordId,
        }),
      )
    } catch (err: any) {
      Alerts.error('There was a problem saving the Record', err.message)

      console.log('save() err', err)
    }
  }

  return (
    <>
      <ButtonWithModal
        {...buttonProps}
        modalElement={({closeHandler}) => (
          <NewRecordModal
            closeHandler={() => {
              closeHandler()
              setBulkImport(false)
            }}
            onSelectBulkImport={() => {
              setBulkImport(true)
            }}
            bulkImport={bulkImport}
            onSelectRecordType={(type) => {
              if (!bulkImport) {
                save(type)
                closeHandler()
              } else if (bulkImport && type) {
                setRecordType(type)
                closeHandler()
              }
            }}
          />
        )}
        variant={buttonProps.variant || 'main'}
      >
        {children || (
          <div className="flex items-center">
            <Icon Icon={IoMdAdd} size="sm" />
            <span className="">New Record</span>
          </div>
        )}
      </ButtonWithModal>

      <UserAnPCheck
        check={(user) => user.anp.role.ops.permissions.canBulkUploadRecords}
      >
        {bulkImport && recordType && (
          <BulkImportRecordsModal
            closeHandler={() => {
              setBulkImport(false)
              setRecordType(undefined)
            }}
            onComplete={() => {
              onComplete?.()
              setBulkImport(false)
              setRecordType(undefined)
            }}
            recordType={recordType}
          />
        )}
      </UserAnPCheck>
    </>
  )
}

export {NewRecordButton}
